module.exports = __webpack_public_path__ + "img/img22.90c1d830.jpg";